/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAiInputRichText = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m17 1.176 2.306 3.518L22.824 7l-3.518 2.306L17 12.824l-2.306-3.518L11.176 7l3.518-2.306zM2 2h10v2H4v16h16v-8h2v10H2zm15 2.824-.862 1.314L14.824 7l1.314.862L17 9.176l.862-1.314L19.176 7l-1.314-.862zM9 8H6V6h3zm4 4H6v-2h7zm0 2h6v5h-6zm2 2v1h2v-1zm-7 2H6v-2h2zm3 0H9v-2h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAiInputRichText as AiInputRichText };
